import { forwardRef, type ButtonHTMLAttributes } from "react";
import { cn } from "@/lib/cn";

// Cascade plan 6.2: the one control ds/ Button cannot be. Button lays its
// content out as a single inline-flex row with a label span, which is right
// for an action and wrong for a whole card or list row that IS the click
// target: a category row with a name above a bar, a tile with a number above
// a caption. Those were native <button>s with hand-written resets. This is
// that button once: block layout, text left, no chrome of its own (the
// caller's classes draw the card), the ds focus ring and hover surface.
export type CardButtonProps = ButtonHTMLAttributes<HTMLButtonElement>;

export const CardButton = forwardRef<HTMLButtonElement, CardButtonProps>(function CardButton(
  { className, type = "button", ...rest },
  ref,
) {
  return <button ref={ref} type={type} className={cn("rc-cardbutton", className)} {...rest} />;
});
